<template>
  <div class="CodeSnippet">
    <code>{{ content }}</code>
    <v-btn @click.prevent="copyText"
           outlined>
      <v-icon>
        fal fa-fw fa-copy
      </v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      required: true,
    }
  },
  methods: {
    copyText() {
      this.$emit('selected', this.content);
    }
  }
}
</script>
